export default function indentContent(content: string, spaces = 2): string {
  const indent = ' '.repeat(spaces);

  return content
    .split('\n')
    .map((line) => (line.trim() ? `${indent}${line}` : line))
    .join('\n');
}
